import { createFileRoute } from "@tanstack/react-router";
import { TrustCentre } from "@/components/TrustCentre";
import { Header, Footer, FloatingWhatsApp } from "@/components/SitePage";
import { buildHead, breadcrumbLD } from "@/content/seo";

const TITLE = "Centro de Confiança — Vilamoura Dreams Cruises";
const DESC =
  "Licenças, seguros, privacidade de dados e segurança de pagamentos por trás do iate Morningstar. Transparência total para quem reserva um charter privado a partir da Marina de Vilamoura.";
const PATH = "/pt/centro-de-confianca";

export const Route = createFileRoute("/pt/centro-de-confianca")({
  component: TrustCentrePage,
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "centro de confiança vilamoura dreams, iate morningstar licença, rnaat 743/2022, luxury reference lda, dgrm skipper, vistoria amn, pagamentos stripe, rgpd charter iate",
      altPath: { en: "/trust-centre", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Centro de Confiança", path: PATH },
            ]),
          ),
        },
      ],
    }),
});

function TrustCentrePage() {
  return (
    <div className="min-h-screen bg-background">
      <Header lang="pt" />
      <main className="pt-20 lg:pt-28">
        <header id="top" className="border-b border-border/40 bg-background">
          <div className="mx-auto max-w-4xl px-6 py-10 md:py-14">
            <p className="text-[11px] uppercase tracking-[0.22em] text-gold-deep font-semibold">
              Vilamoura Dreams Cruises
            </p>
            <h1 className="mt-2 font-serif text-3xl leading-tight text-foreground md:text-5xl">
              Centro de Confiança
            </h1>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-muted-foreground">
              Todas as garantias por trás de um charter a bordo do Morningstar — licenças,
              seguros, credenciais da tripulação, privacidade de dados e segurança de
              pagamentos, verificáveis junto das autoridades portuguesas e europeias que
              regulam a operação.
            </p>
          </div>
        </header>
        <section className="mx-auto max-w-4xl px-6 py-12 md:py-16">
          <TrustCentre lang="pt" />
        </section>
      </main>
      <Footer lang="pt" />
      <FloatingWhatsApp lang="pt" />
    </div>
  );
}